const trackForecastOutlookLink = (doTrackFeed, props) => {
  doTrackFeed('Clicked Link', {
    linkLocation: 'forecast outlook',
    category: 'homepage',
    ...props,
  });
};

export default trackForecastOutlookLink;
